import { z } from "zod";

export const PortalNotificationTypeSchema = z.enum([
  "ACCESS_REQUEST",
  "ATTENDANCE",
  "SITE_FILE",
  "SITE_INDUCTION",
  "DOCUMENT_REVIEW",
  "TOOLBOX_TALK",
  "RFI",
  "CREDENTIAL",
  "CREDENTIAL_EXPIRY",
  "SITE_UPDATE",
]);

export const PortalNotificationSchema = z.object({
  id: z.string(),
  type: PortalNotificationTypeSchema,
  title: z.string(),
  body: z.string(),
  href: z.string().nullable().optional(),
  readAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});

// #2411 server-boundary variant: the mobile app parses the permissive base;
// the notification routes serialise through the Strict form.
export const PortalNotificationStrict = PortalNotificationSchema.strict();

export type PortalNotification = z.infer<typeof PortalNotificationSchema>;

export const PortalNotificationsResponse = z
  .object({
    notifications: z.array(PortalNotificationSchema),
  })
  .strict();

export type PortalNotificationsResponse = z.infer<
  typeof PortalNotificationsResponse
>;

export const PortalNotificationResponse = z
  .object({
    notification: PortalNotificationSchema,
  })
  .strict();

export const PortalNotificationsResponseStrict = z
  .object({ notifications: z.array(PortalNotificationStrict) })
  .strict();

export const PortalNotificationResponseStrict = z
  .object({ notification: PortalNotificationStrict })
  .strict();

export type PortalNotificationResponse = z.infer<
  typeof PortalNotificationResponse
>;
